import { apiFetch } from "../utils/apiFetch"

export function validateApplication(applicationId: string) {
  return apiFetch(`/api/euipo/validate/${applicationId}`, {
    method: "POST"
  })
}

export function submitApplication(applicationId: string) {
  return apiFetch(`/api/euipo/submit/${applicationId}`, {
    method: "POST"
  })
}

export async function checkOAuthStatus(): Promise<{
  authorized: boolean
  hasDocumentAccess: boolean
}> {
  const res = await apiFetch("/api/euipo/oauth/status")
  return {
    authorized: res.authorized,
    hasDocumentAccess: res.hasDocumentAccess
  }
}
